import React, { useState } from "react";
import { Search, X } from "lucide-react";

export default function GlobalSearchBar({ onSearch }) {
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({
    category: "",
    role: "",
    country: "",
    status: "",
  });

  const handleChange = (e) =>
    setFilters({ ...filters, [e.target.name]: e.target.value });

  const handleSearch = () => {
    setOpen(false);
    onSearch(filters);
  };

  return (
    <>
      {/* Collapsed Search Bar */}
      {!open && (
        <div
          onClick={() => setOpen(true)}
          className="mx-auto mt-6 w-full max-w-3xl flex items-center gap-2 bg-white/10 backdrop-blur-lg rounded-full px-5 py-2 cursor-pointer hover:bg-white/20 transition"
        >
          <Search className="w-5 h-5 text-slate-300" />
          <span className="text-slate-300 text-sm">
            Search professionals, brokers, fintechs...
          </span>
        </div>
      )}

      {/* Expanded Overlay */}
      {open && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-slate-900 text-white rounded-2xl p-6 w-[90%] max-w-2xl relative">
            <button
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 text-slate-400 hover:text-white"
            >
              <X size={20} />
            </button>

            <h2 className="text-lg font-semibold mb-4">
              🔍 Search Verified Members
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <select
                name="category"
                onChange={handleChange}
                className="bg-slate-800 border border-slate-700 rounded-md p-2"
              >
                <option value="">Select Category</option>
                <option>Traders</option>
                <option>Brokers</option>
                <option>Fintechs</option>
                <option>Startups</option>
                <option>Institutions</option>
              </select>

              <input
                name="role"
                placeholder="Subcategory / Role"
                onChange={handleChange}
                className="bg-slate-800 border border-slate-700 rounded-md p-2"
              />

              <input
                name="country"
                placeholder="Country"
                onChange={handleChange}
                className="bg-slate-800 border border-slate-700 rounded-md p-2"
              />

              <select
                name="status"
                onChange={handleChange}
                className="bg-slate-800 border border-slate-700 rounded-md p-2"
              >
                <option value="">Verification Status</option>
                <option>Verified</option>
                <option>Pending</option>
                <option>New</option>
              </select>
            </div>

            <div className="flex justify-center mt-5">
              <button
                onClick={handleSearch}
                className="bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-2 rounded-full font-semibold hover:scale-105 transition"
              >
                Search Now
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
